import { useRef } from 'react'
import { HandHeart, Heart, Leaf } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { Card, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import SectionHeading from '@/components/SectionHeading'
import { hotel } from '@/data/hotel'
import { useGSAP } from '@/lib/gsap'
import { setupReveals } from '@/lib/reveal'

const values = [
  {
    icon: Heart,
    title: 'Acolhimento',
    description: 'Recebemos cada hóspede com o carinho de quem abre as portas da própria casa.',
  },
  {
    icon: HandHeart,
    title: 'Atendimento próximo',
    description: 'Uma equipe atenta, pronta para tornar cada detalhe da sua estadia especial.',
  },
  {
    icon: Leaf,
    title: 'Tranquilidade',
    description: 'Um refúgio pensado para relaxar e se reconectar com o que importa.',
  },
]

function SobrePage() {
  const root = useRef(null)
  useGSAP(() => setupReveals(root.current), { scope: root })

  return (
    <div ref={root}>
      {/* Hero */}
      <section className="relative isolate flex h-[55vh] min-h-[380px] items-center justify-center overflow-hidden">
        <div className="absolute inset-0 -z-10 overflow-hidden">
          <img
            data-parallax="12"
            src="/images/hotel-banner.jpg"
            alt="Star Hotel"
            className="size-full object-cover"
          />
        </div>
        <div className="absolute inset-0 -z-10 bg-ink/65" />
        <div className="flex flex-col items-center gap-5 px-4 text-center text-ink-foreground">
          <Badge data-reveal variant="glass" className="h-7 px-3">
            Nossa história
          </Badge>
          <h1 data-split className="text-5xl font-bold md:text-7xl">Sobre o Star Hotel</h1>
        </div>
      </section>

      {/* Conteúdo */}
      <section className="py-20 md:py-24">
        <div className="container-page flex max-w-3xl flex-col gap-6 text-center text-lg leading-relaxed text-pretty text-muted-foreground">
          <p data-words className="font-heading text-2xl leading-snug text-foreground md:text-4xl">
            Fundado em {hotel.founded}, o Star Hotel nasceu do desejo genuíno de proporcionar uma
            experiência única e acolhedora aos nossos visitantes.
          </p>
          <p data-reveal>
            Com um carinho especial pela cidade de Limoeiro e por seus encantos, nossa missão é
            criar um ambiente onde o <strong className="font-medium text-primary">conforto</strong>,
            o <strong className="font-medium text-primary">bem-estar</strong> e a{' '}
            <strong className="font-medium text-primary">tranquilidade</strong> se encontram,
            oferecendo aos nossos hóspedes um refúgio perfeito para relaxar e se reconectar com o
            que realmente importa.
          </p>
          <p data-reveal>
            Venha viver momentos inesquecíveis e sentir a verdadeira essência de Limoeiro, com a
            certeza de que cada instante será repleto de conforto e carinho.
          </p>
        </div>
      </section>

      {/* Valores */}
      <section className="bg-secondary/60 py-20 md:py-24">
        <div className="container-page flex flex-col gap-14">
          <SectionHeading eyebrow="O que nos move" title="Nossos valores" />
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-3">
            {values.map(({ icon: Icon, title, description }) => (
              <Card key={title} data-reveal className="[--card-spacing:--spacing(8)]">
                <CardHeader className="justify-items-center gap-3 text-center">
                  <span className="mb-2 flex size-14 items-center justify-center rounded-full bg-secondary text-primary">
                    <Icon className="size-6" />
                  </span>
                  <CardTitle className="text-xl font-bold">{title}</CardTitle>
                  <CardDescription className="leading-relaxed">{description}</CardDescription>
                </CardHeader>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}

export default SobrePage
